var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNbaCourt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1080.85 1142.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke-width:4px;}.cls-1,.cls-2,.cls-3{stroke:#000;stroke-miterlimit:10;}.cls-1,.cls-2,.cls-3,.cls-4{fill:none;}.cls-5{clip-path:url(#clippath-2);}.cls-2{stroke-width:8px;}.cls-3{stroke-width:6px;}.cls-6{clip-path:url(#clippath-1);}.cls-7{clip-path:url(#clippath);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m734.3,630.07h-394.21c17.11-85.9,34.21-171.8,51.32-257.71,7.89,2.46,18.46,5.49,31.06,8.34,2.08.47,18.64-12.86,13.36-16.26-3.57-2.3-16.06-7.9-20.43-9.45-.01,0-.02,0-.02-.02-.47-.67,11.51-32.62,19.17-27.05q5.62,4.09,11.74,8.43c6.1,4.32,19.6-7.69,16.34-11.49-7.83-9.12-8.25-9.8-14.98-18.04-2.32-2.84,22.02-27.46,27.74-18.21,3.32,5.36,4.68,7.9,8.43,14.3,3.49,5.96,19.68-5.88,19.15-7.4-2.04-5.87-3.74-12.09-5.79-17.28-6.66-16.92,32.77-8.85,32.77-8.85,1.05,9.12,1.22,9.28,3.49,30.47.39,3.68,16.2,7.76,17.66-3.83,1.02-8.09,2.7-22.56,3.96-31.57.95-6.79,36.19,1.43,33.49,9.28q-5.58,16.19-8.04,22.72c-3.64,9.68,14.08,17.09,19.23,7.66q8.06-14.74,11.23-19.4c2.91-4.27,19.94,24.48,24.26,22.81,2.4-.93-14.76,16.53-12.51,15.83,10.87-3.37,9.03,17.1,14.55,13.02q11.74-8.68,16.85-12.77c2.41-1.93,20.46,4.08,19.66,7.15-1.57,6.06.44,13.63-1.28,19.66-.7,2.44-5.11,4.34-18.64,10.98-27.2,13.34-9.26,20.88,5.02,18.64,15.15-2.38,25.71-3.91,30.98-4.6,14.81,84.88,29.62,169.76,44.43,254.64Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m932.56,987.07H166.31c-76.99,0-139.41-62.42-139.41-139.41v-451.91c0-76.99,62.42-139.41,139.41-139.41h766.25c31.81-21.39,101.04,44.25,139.41,139.41v451.91c0,76.99-62.42,139.41-139.41,139.41Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 435.69,
    y: 122.41,
    width: 208.48,
    height: 112.64
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.62,
    y: 0.62,
    width: 1080,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    y: 1007,
    width: 1080,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: -535.23,
    y: 536,
    width: 1080,
    height: 8,
    transform: "translate(544.77 535.23) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 536.85,
    y: 536,
    width: 1080,
    height: 8,
    transform: "translate(1616.85 -536.85) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 370.72,
    y: 6.41,
    width: 342.13,
    height: 403.57
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 542.49,
    cy: 409.83,
    r: 128.83
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 540.62,
    cy: 1011.85,
    r: 126.95
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 67.55,
    y1: 9.77,
    x2: 67.55,
    y2: 301.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1013.72,
    y1: 9.77,
    x2: 1013.72,
    y2: 301.38
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 540.95,
    cy: 113.96,
    r: 508.11
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 604.99,
    y1: 89.64,
    x2: 476.25,
    y2: 89.64
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 540.62,
    cy: 122.41,
    r: 18.09
  }), /*#__PURE__*/React.createElement("rect", {
    x: 531.8,
    y: 89.68,
    width: 17.64,
    height: 14.64
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 540.62,
    cy: 122.41,
    r: 87.61
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 452.94,
    y1: 94.83,
    x2: 452.94,
    y2: 124.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 628.26,
    y1: 94.83,
    x2: 628.26,
    y2: 124.83
  }), /*#__PURE__*/React.createElement("rect", {
    x: 715.76,
    y: 241.96,
    width: 14.3,
    height: 3.58
  }), /*#__PURE__*/React.createElement("rect", {
    x: 715.76,
    y: 311.08,
    width: 14.3,
    height: 3.58
  }), /*#__PURE__*/React.createElement("rect", {
    x: 715.76,
    y: 173.84,
    width: 14.3,
    height: 3.58
  }), /*#__PURE__*/React.createElement("rect", {
    x: 715.76,
    y: 152.32,
    width: 14.3,
    height: 3.58
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.55,
    y: 241.96,
    width: 14.3,
    height: 3.58
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.55,
    y: 311.08,
    width: 14.3,
    height: 3.58
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.55,
    y: 173.84,
    width: 14.3,
    height: 3.58
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.55,
    y: 152.32,
    width: 14.3,
    height: 3.58
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNbaCourt);
export default __webpack_public_path__ + "static/media/nba-court.7081ddd99780d4cd1320e3d7d005f542.svg";
export { ForwardRef as ReactComponent };